import { AuditTableDictionaryItem } from '@/models/dictionary/auditTable';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IAuditTableDictionaryApi } from '@/types/dictionary';

export const useAuditTableDictionary = defineStore('auditTableDictionary', () => {
    const itemsAll = shallowRef<AuditTableDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: IAuditTableDictionaryApi[]) {
        itemsAll.value = data.map((item) => new AuditTableDictionaryItem(item));
    }

    function idByCode(code: string): number | null {
        const normalized = code.trim().toLowerCase();
        if (!normalized) return null;
        const item = itemsAll.value.find((row) => row.code.toLowerCase() === normalized);
        return item?.id ?? null;
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        idByCode,
        setData,
    };
});
